import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        fullScreenOpen: false,
        fullScreenOpenPos: 0,
        fullScreenOpen2: false,
        fullScreenOpenPos2: 0,
        fullScreenOpen3: false,
        fullScreenOpenPos3: 0,
        whatsappModal: {
            visible: false,
            phone: '',
            message: '',
            propertyCod: '',
            propertyMessage: '',
            propertyFinality: 'sale',
        },
    },
    mutations: {
        toggleFullScreen: function (state, open) {
            state.fullScreenOpen = open;
        },
        setFullScreenOpenPos: function (state, pos) {
            state.fullScreenOpenPos = pos;
        },
        toggleFullScreen2: function (state, open) {
            state.fullScreenOpen2 = open;
        },
        setFullScreenOpenPos2: function (state, pos) {
            state.fullScreenOpenPos2 = pos;
        },
        toggleFullScreen3: function (state, open) {
            state.fullScreenOpen3 = open;
        },
        setFullScreenOpenPos3: function (state, pos) {
            state.fullScreenOpenPos3 = pos;
        },
        openWhatsappModal: function (state, payload) {
            state.whatsappModal.visible = true;
            state.whatsappModal.phone = payload.phone || '';
            state.whatsappModal.message = payload.message || '';
            state.whatsappModal.propertyCod = payload.propertyCod || '';
            state.whatsappModal.propertyMessage = payload.propertyMessage || '';
            state.whatsappModal.propertyFinality = payload.propertyFinality || 'sale';
        },
        closeWhatsappModal: function (state) {
            state.whatsappModal.visible = false;
            state.whatsappModal.phone = '';
            state.whatsappModal.message = '';
            state.whatsappModal.propertyCod = '';
            state.whatsappModal.propertyMessage = '';
            state.whatsappModal.propertyFinality = 'sale';
        },
    },
    actions: {
        toggleFullScreen: function (context, todoModel) {
            context.commit('toggleFullScreen', todoModel);
        },
        setFullScreenOpenPos: function (context, pos) {
            context.commit('setFullScreenOpenPos', pos);
        },
        toggleFullScreen2: function (context, todoModel) {
            context.commit('toggleFullScreen2', todoModel);
        },
        setFullScreenOpenPos2: function (context, pos) {
            context.commit('setFullScreenOpenPos2', pos);
        },
        toggleFullScreen3: function (context, todoModel) {
            context.commit('toggleFullScreen3', todoModel);
        },
        setFullScreenOpenPos3: function (context, pos) {
            context.commit('setFullScreenOpenPos3', pos);
        }
    }
});
